import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="footer-box">
              <h4>GV Travels Madurai</h4>
              <p>
                GV Travels is one of the leading cab services in Madurai. We give the best rides for low prices with the best quality. We are the best cab booking service in Madurai.
              </p>
              {/* <div className="footer-contact">
                <p>
                  <i className="fas fa-phone"></i>
                  <a href="tel:+918072938793">+91 8072938793</a>
                </p>
                <p>
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:gvtravelsmadurai@gmail.com">gvtravelsmadurai@gmail.com</a>
                </p>
              </div> */}
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="footer-box">
              <h4>QUICK LINKS</h4>
              <ul className="footer-links">
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#car-rental">Tariffs</a></li>
                <li><a href="#tour-packages">Tour Packages</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="footer-box">
              <h4>CONTACT US</h4>
              <div className="footer-contact">
                <p>
                  <i className="fas fa-building"></i> GV Travels Madurai
                </p>
                <p>
                  <i className="fas fa-map-marker-alt"></i> Sembaruthi Nagar, Vilangudi, Madurai - 625018.
                </p>
                <p>
                  <i className="fas fa-phone"></i>
                  <a href="tel:+918072938793"> +91 8072938793</a>
                </p>
                <p>
                  <i className="fab fa-whatsapp"></i>
                  {/* <a href="https://wa.me/919486757405"> +91 9486757405</a> */}
                  <a href="https://wa.me/919486757405" target="_blank" rel="noopener noreferrer">
                    +91 9486757405
                  </a>
                </p>
                <p>
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:gvtravelsmadurai@gmail.com"> gvtravelsmadurai@gmail.com</a>
                </p>
                
                <p>
                  <i className="fab fa-instagram"></i>
                  <a href="https://www.instagram.com/gv_travelsmadurai" target="_blank" rel="noopener noreferrer">
                    gv_travelsmadurai
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <p>© 2026 GV Travels Madurai. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
